import type { ActionApi, AttributesTarget } from '../../../../common/types/index.tsx';

export const setSummableColumns =
	(column: AttributesTarget): ActionApi =>
	async ({ setState, getState }) => {
		const summableColumns = new Set(getState().summableColumns ?? []);
		if (column.isSummable) {
			summableColumns.add(column.id);
		} else {
			summableColumns.delete(column.id);
		}

		setState({
			summableColumns,
		});
	};
